import { useQuery } from '@tanstack/react-query';
import api from '../../http';

interface RequiredConsent {
	policyType: string;
	consentType: string;
	policyVersionId: string;
	versionNumber: string;
	effectiveDate: Date;
}

export interface ConsentStatus {
	allGranted: boolean;
	accepted: boolean;
	requiredConsents: RequiredConsent[];
	totalActiveConsents: number;
	totalPendingConsents: number;
}

export const useConsentStatus = (enabled: boolean) => {
	return useQuery<ConsentStatus>({
		queryKey: ['consent', 'status'],
		queryFn: async () => {
			const { data } = await api.get<ConsentStatus>('/consent/status');
			return data;
		},
		enabled,
		staleTime: 0,
		refetchOnMount: true,
		retry: false,
	});
};
